<div style="display: flex; flex-direction: column">
  <small style="max-width: 80%; color: gray; padding-top: 15px">
    Recorrido del día
  </small>
  <div style="display: flex; gap: 3px; padding-top: 5px">
    <div style="width: 100%">
      <app-datetime-picker
        [(date)]="date"
        (dateChange)="listarViajes()"
        pickerMode="calendar"
      ></app-datetime-picker>
    </div>
  </div>

  @if (buscando) {
    <div style="height: 100%; width: 100%; margin-top: 10%" align="center">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  }
</div>
